export default class StoreIndex {

  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    this.dataTable = $('.stores-table').DataTable({
      "info": false,
      "lengthChange": false,
      retrieve: true,
      "searching": true,
      "language": {
          url: '/assets/data-tables/locales/' + I18n.locale + '.json',
          previous: "<i class='mdi mdi-chevron-left'>",
          next: "<i class='mdi mdi-chevron-right'>"
      },
      dom: 'Bfrtip',
      paging: false,
      buttons: [],
      "columnDefs": [
        {
          "targets": [6],
          "orderable": false,
        }]
    });

    this.dataTable.on('draw', () => {
      if ($(".placed").length == 0) {
        $("#seach-bar-wrapper").html($(".form-control-sm"));
        $(".form-control-sm").attr("placeholder", "Rechercher...");
        $(".form-control-sm").addClass("placed").removeClass("form-control-sm");
      }

      if($('.dataTables_filter').length >= 0) {
        $('.dataTables_filter').addClass('d-none'); 
      }
    });
  }

  onDataChanged(data) {
    
  }

  onDestroy() {
   if (this.dataTable) {
     this.dataTable.destroy();
      this.dataTable = null;
   }
  }
}